import {AppBar, Badge, Box, Button, Container, IconButton, Stack, Toolbar, Typography} from "@mui/material";
import {withStyles} from "@mui/styles";
import TwitterIcon from '@mui/icons-material/Twitter';
import XDLoadoutLogo from "./components/XDLoadoutLogo";
import {useIsMobileHook} from "./utils";
import MobileMenu from "./MobileMenu";
import InfoIcon from '@mui/icons-material/Info';
import MetaIcon from '@mui/icons-material/AutoGraph';
import MainBg from './assets/main-bg.png'
import LoginButton from "./LoginButton";
import React, {useEffect, useState} from "react";
import {Link, Outlet} from "react-router-dom";
import RootContextProvider from "./context/RootContextProvider";
import AdsenseComponent from "./components/AdsenseComponent";


const styles = theme => ({
    appBarSpacer: theme.mixins.toolbar,
    pageButton: {
        backgroundColor: 'rgb(0,0,0,0)',

    }
});

const style = withStyles(styles)
export const mainGradient = 'linear-gradient(49deg, rgb(37 40 60) -40%, rgb(34 38 64) 60%, rgb(18 61 86) 100%)';

const pages = [
    {
        name: "About",
        path: "/about",
        icon: <InfoIcon/>
    },
    {
        name: "Meta",
        path: "/meta",
        highlight: "NEW",
        icon: <MetaIcon/>
    },
    // {
    //     name: "Featured",
    //     path: "/featured",
    //     icon: <FeaturedIcon/>
    // }
]

const LOGIN_ENABLED_COOKIE = 'login-enabled';

function App({classes}) {
    const isMobile = useIsMobileHook()
    const [secretCounter, setSecretCounter] = useState(0)

    useEffect(() => {
        if (secretCounter > 4) {
        }
    }, [secretCounter])

    return (
        <RootContextProvider>
            <Box sx={{backgroundColor: 'background.default', height: '100%', minHeight: '100vh'}}>
                <Box sx={{
                    height: '100%', width: '100%', position: 'absolute', backgroundImage: `url(${MainBg})`,
                    backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: '100% 100%',
                    overflow: 'auto', '&::-webkit-scrollbar': {display: 'none'}
                }}>
                    <Box sx={{flexGrow: 1, paddingBottom: '15px'}}>
                        <AppBar component='nav' sx={{background: mainGradient}}>
                            <Toolbar>
                                <Stack direction='row' alignItems='center' justifyContent='space-between' width='100%'>
                                    <Stack direction='row' alignItems='center'>
                                        <MobileMenu navItems={pages}/>
                                        <XDLoadoutLogo height={isMobile ? '32px' : '40px'}/>
                                        <IconButton aria-label="twitter" href='https://twitter.com/XDLoadout'>
                                            <TwitterIcon sx={{color: 'white'}}/>
                                        </IconButton>
                                        {isMobile ? null :
                                            <Stack direction='row' sx={{pl: '25px'}}>
                                                {pages.map((page) =>
                                                    <Badge key={`page-${page.name}`} badgeContent={page.highlight} color="error"
                                                           sx={{
                                                               "& .MuiBadge-badge": {
                                                                   m: '10px 3px 0 0',
                                                                   fontSize: 11,
                                                                   height: 15,
                                                                   minWidth: 15
                                                               }
                                                           }}>
                                                        <Link to={page.path}>
                                                            <Button variant='text' key={page.name}
                                                                    sx={{
                                                                        m: '5px',
                                                                        background: 'none',
                                                                        color: 'white',
                                                                        transition: 'text-shadow 0.3s ease',
                                                                        '&:hover': {
                                                                            textShadow: '#ffffffcc 0 0 10px',
                                                                            background: 'none'
                                                                        }
                                                                    }}>
                                                                {page.name}
                                                            </Button>
                                                        </Link>
                                                    </Badge>
                                                )}
                                            </Stack>
                                        }
                                    </Stack>
                                    <LoginButton enabled={true}/>
                                </Stack>
                            </Toolbar>
                        </AppBar>
                    </Box>
                    <Container sx={{p: {xs: '0 10px', md: '0 24px'}, maxWidth: {md: '1220px'}, display: 'relative'}}>
                        {secretCounter > 10 ? <div style={{position: 'absolute', left: 'calc(((100vw - 1268px) / 4) - 100px)', top: '20vh', height: '800px', width: '200px'}}>
                            <AdsenseComponent adClient="ca-pub-9475011578827400" adSlot="3088828307" adFormat="auto"/>
                        </div> : null}
                        <Stack>
                            <div className={classes.appBarSpacer}></div>
                            <Box sx={{minHeight: { xs: '80vh', md: '85vh'}}}>
                                {/*{children}*/}
                                <Outlet/>
                            </Box>
                            <Typography variant='body2' textAlign='center' onClick={() => setSecretCounter(secretCounter + 1)}
                                        sx={{padding: '5px 0 0 0', fontStyle: 'oblique', color: 'text.primary'}}>
                                © {new Date().getYear() + 1900} - XDLoadout<br/>
                            </Typography>
                            <Typography sx={{
                                pb: '5px',
                                textAlign: 'center',
                                fontStyle: 'oblique',
                                color: 'text.primary',
                                fontSize: '0.7rem'
                            }}>
                                XDLoadout has no affiliation with XDefiant or Ubisoft
                            </Typography>
                        </Stack>
                    </Container>
                </Box>
            </Box>
        </RootContextProvider>
    )
}

export default style(App)
